import * as React from 'react';
import { Tooltip } from '../../Tooltip';
import { TOOLTIP_COMMON_PROPS } from './tooltipCommonProps';
const DEFAULT_DELAY = 1000;
export class LongPress extends React.Component {
    constructor() {
        super(...arguments);
        this.handlePress = () => {
            const { delay = DEFAULT_DELAY, onLongPress } = this.props;
            this.pressTimer = setTimeout(onLongPress, delay);
        };
        this.handleRelease = () => {
            clearTimeout(this.pressTimer);
        };
        this.render = () => {
            const { children } = this.props;
            if (typeof children === 'string' || !children) {
                return children || '';
            }
            return React.cloneElement(children, {
                onTouchStart: this.handlePress,
                onTouchEnd: this.handleRelease,
                onMouseDown: this.handlePress,
                onMouseUp: this.handleRelease,
                onMouseLeave: this.handleRelease,
            });
        };
    }
}
export class MobileTooltip extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            shown: false,
        };
        this.show = () => {
            this.setState({
                shown: true,
            });
        };
        this.hide = () => {
            this.setState({
                shown: false,
            });
        };
        this.render = () => {
            const { children, tooltip } = this.props;
            return (React.createElement(Tooltip, { ...TOOLTIP_COMMON_PROPS, content: tooltip, disabled: true, shown: this.state.shown, onClickOutside: this.hide },
                React.createElement(LongPress, { onLongPress: this.show }, children)));
        };
    }
}
//# sourceMappingURL=MobileTooltip.js.map